import { type ComponentType, useEffect, useState } from 'react';
import { MyTrackerEvents, sendMtEvent, sendYaMetrikaEvent, YaMetrikaEvents } from '../../core/services/myTracker';
import { PwaInstallSafari } from '../PwaInstallSafari';
import { PwaInstallSafariNative } from '../PwaInstallSafariNative';
import { PwaInstallSafariNativeVideo } from '../PwaInstallSafariNativeVideo';
import { InstallSafariVariant, pickInstallSafariVariant } from './installSafariVariant';

const VARIANT_TO_PAGE: Record<InstallSafariVariant, ComponentType> = {
  [InstallSafariVariant.Control]: PwaInstallSafari,
  [InstallSafariVariant.Native]: PwaInstallSafariNative,
  [InstallSafariVariant.NativeVideo]: PwaInstallSafariNativeVideo,
};

const VARIANT_TO_TRACKER_EVENTS: { [key in InstallSafariVariant]: { mt: MyTrackerEvents; ym: YaMetrikaEvents } } = {
  [InstallSafariVariant.Control]: {
    mt: MyTrackerEvents.PwaInstallInstructionControlOpened,
    ym: YaMetrikaEvents.PwaInstallInstructionControlOpened,
  },
  [InstallSafariVariant.Native]: {
    mt: MyTrackerEvents.PwaInstallInstructionNativeOpened,
    ym: YaMetrikaEvents.PwaInstallInstructionNativeOpened,
  },
  [InstallSafariVariant.NativeVideo]: {
    mt: MyTrackerEvents.PwaInstallInstructionNativeVideoOpened,
    ym: YaMetrikaEvents.PwaInstallInstructionNativeVideoOpened,
  },
};

export function PwaInstallSafariAbTest() {
  const [variant, setVariant] = useState<InstallSafariVariant | null>(null);

  useEffect(() => {
    pickInstallSafariVariant().then(setVariant);
  }, []);

  useEffect(() => {
    if (!variant) return;

    const event = VARIANT_TO_TRACKER_EVENTS[variant];
    sendMtEvent(event.mt);
    sendYaMetrikaEvent(event.ym);
  }, [variant]);

  if (!variant) {
    return null;
  }

  const Page = VARIANT_TO_PAGE[variant];

  return <Page />;
}
